import { Observable } from 'rxjs';

import { UnitResult } from '../../../error';
import { EventType } from '../Model/eventType';

export abstract class EventTypesProvider {
    abstract getEvents(): Observable<UnitResult<EventType[]>>;
}
